/** Area label — Reserve → User Permissions (Activity tab) */
import type { ReserveRetailPermissionAreaKey } from "./ReserveRetailPermissionsFields";

export const bookingActionsArea = "Booking Actions" as const;
export const guestCommunicationArea = "Guest Communication" as const;
export const instructorScheduleArea = "Instructor Schedule" as const;
export const manageActivityArea = "Manage Activity" as const;
export const manageLocationsArea = "Manage Locations" as const;
export const reportsArea = "Reports" as const;
export const settingsAccessArea = "Settings Access" as const;

export const bookingActionsPermissionList = [
  "Add booking",
  "Add to Standby List",
  "Book or Edit Past Reservations",
  "Book in Non Web Reservable or Disabled slots",
  "Book or Seat At blocked locations",
  "change property settings",
  "check-in/check-out guest",
  "confirm/reject Standby",
  "edit bookings",
  "edit standby parties",
  "guest details display settings",
  "negotiable deposit fee",
  "negotiable rates",
  "overbook",
  "undo-cancel",
  "undocheck-in",
] as const;

export const guestCommunicationPermissionList = [
  "book in slots with inappropriate size",
  "page parties",
  "view feedback",
] as const;

export const instructorSchedulePermissionList = [
  "Add staff",
  "delete staff",
  "edit staff",
  "schedule staff",
] as const;

export const manageActivityPermissionList = [
  "cancel activity",
  "create activity",
  "create template",
  "manage activity blocks",
  "modify activity",
  "modify template",
] as const;

export const manageLocationsPermissionList = [
  "move seated parties",
  "no-show reservations",
] as const;

export const reportsPermissionList = [
  "generate reports",
  "schedule reports",
] as const;

export const settingsAccessPermissionList = [
  "Activities",
  "advanced settings",
  "app settings",
  "authorize form code",
  "blocks",
  "cancellation policy",
  "covers",
  "custom guest fields",
  "discount promo code",
  "guest charges",
  "location group",
  "packages",
  "permissions",
  "roles",
  "shift statistics",
  "templates",
  "users",
] as const;

export type { ReserveRetailPermissionAreaKey } from "./ReserveRetailPermissionsFields";
export {
  clientProfileArea,
  clientProfilePermissionList,
  commissionSetupArea,
  commissionSetupPermissionList,
  fiscalReportsArea,
  fiscalReportsPermissionList,
  interfaceArea,
  interfacePermissionList,
  inventoryManagementArea,
  inventoryManagementPermissionList,
  retailOperationsArea,
  retailOperationsPermissionList,
  retailReportsArea,
  retailReportsPermissionList,
  retailSetupArea,
  retailSetupPermissionList,
  retailTransactionsArea,
  retailTransactionsPermissionList,
  utilitiesArea,
  utilitiesPermissionList,
} from "./ReserveRetailPermissionsFields";

export type ReserveUserPermissionAreaKey =
  | typeof bookingActionsArea
  | typeof guestCommunicationArea
  | typeof instructorScheduleArea
  | typeof manageActivityArea
  | typeof manageLocationsArea
  | typeof reportsArea
  | typeof settingsAccessArea
  | ReserveRetailPermissionAreaKey;
